import { History } from 'history';
import { combineReducers } from 'redux';
import formTemplate from "./formTemplate/formTemplateSlice";
import Tenant from "./tenant/slice";

const RootReducer = (history: History) =>
  combineReducers({
    Tenant,
    formTemplate
  })
  

export default RootReducer
